/** Promise that resolves after a delay */
export const delay = (seconds: number) => new Promise<void>((resolve) => setTimeout(resolve, seconds * 1000))
